import { Link } from "gatsby";
import * as React from "react";
import { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import SignInBar from "../SignInBar/SignInBar";
import PointsHeader from "./HelperComponents/PointsHeader";
import {
  elementFocusable,
  elementInvisible,
  optionsContainer,
} from "./Header.module.scss";
import {
  Branding,
  Logo,
  Menu,
  NavigationContainer,
  PrimaryMenu,
  SecondaryMenu,
  StyledRow,
} from "./HeaderHelpers";
import { IHeaderProps } from "./HeaderProps";
import { useSelector } from "react-redux";
import { useMobileDetectContext } from "../../../context/MobileDetectContext";
import { useHeaderSliceContext } from "../../../context/SliceContexts/HeaderContext";

const Header: React.FC<IHeaderProps> = (props) => {
  const { location } = useHeaderSliceContext();
  const [menuOpen, setMenuOpen] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);
  const { isMobileOnly } = useMobileDetectContext();
  const isLoggedIn = useSelector((state: any) => state.member.isLoggedIn);
  const member = useSelector((state: any) => state.member);

  useEffect(() => {
    if (menuOpen || loginOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  }, [menuOpen]);
  const handleMenuOpen = (e: any) => {
    setMenuOpen(!menuOpen);
    setLoginOpen(false);
    e.preventDefault();
  };
  const handleLoginOpen = () => {
    setLoginOpen(loginOpen === false);
    setMenuOpen(false);
  };

  return (
    <>
      <div>
        <a
          id="skip-link"
          href="#main-content"
          className={`${elementInvisible} ${elementFocusable}`}
        >
          Skip to main content
        </a>
      </div>
      <div
        className={`mobile-overflow-hidden ${menuOpen ? "d-block" : "d-none"}`}
      ></div>
      <NavigationContainer role="navigation" menuOpen={menuOpen}>
        <Container fluid="sm" className={optionsContainer}>
          <StyledRow>
            <Branding as={Col}>
              <Link id={`logo`} to="/">
                <Logo />
              </Link>
            </Branding>

            {!isMobileOnly ? (
              <React.Fragment>
                <Col>
                  <PrimaryMenu isMobileOnly={isMobileOnly}></PrimaryMenu>
                </Col>
                <Col xs="auto" className="pl-0 pr-0 hrDropDown">
                  <SignInBar
                    location={location}
                    // location={props.location}
                    showDropdown={loginOpen}
                    setShowDropdown={handleLoginOpen}
                  />
                </Col>
                {isLoggedIn && (
                  <Col className="point-header-col">
                    <PointsHeader />
                  </Col>
                )}
                <Col id="secondary-nav" xs="auto" className="d-none d-lg-block">
                  <SecondaryMenu
                    menuOpen={menuOpen}
                    isMobileOnly={isMobileOnly}
                    isLoggedIn={isLoggedIn}
                  ></SecondaryMenu>
                </Col>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Col
                  xs="auto"
                  className="pl-0 pr-0 mbDropDown"
                  style={
                    isLoggedIn && member.memberPointsTally === 0
                      ? { right: "70px" }
                      : isLoggedIn
                      ? { right: "100px" }
                      : {}
                  }
                >
                  <SignInBar
                    location={location}
                    // location={props.location}
                    showDropdown={loginOpen}
                    setShowDropdown={handleLoginOpen}
                  />
                </Col>
                <Col className="point-header-col">
                  <PointsHeader />
                </Col>
                <Col>
                  <Menu
                    handleMenuOpen={handleMenuOpen}
                    menuOpen={menuOpen}
                    isMobileOnly={isMobileOnly}
                    isLoggedIn={isLoggedIn}
                  />
                </Col>
              </React.Fragment>
            )}
          </StyledRow>
        </Container>
      </NavigationContainer>
    </>
  );
};

export default Header;
